export const enum Pricing {
    NONE,
    ALL,
    US,
    CA
};
